import { render, staticRenderFns } from "./ToDoListPrivateAssignDialog.vue?vue&type=template&id=58b17f2a&scoped=true"
import script from "./ToDoListPrivateAssignDialog.vue?vue&type=script&lang=js"
export * from "./ToDoListPrivateAssignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b17f2a",
  null
  
)

export default component.exports